import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { Injectable } from '@angular/core';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { FavouriteModel } from '../models/favourite.model';

@Injectable({
  providedIn: 'root',
})
export class FavouriteService extends BaseFucntionsService<FavouriteModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.Favorite.FavoritesController, apiClient);
  }

  getCourseFav(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.Favorite.TraineeFavoriteCourse(courseId)}`);
  }
  updatStatus(courseId: number){
    return this.apiClient.create(ApplicationRoutes.Favorite.FavoritesController, courseId);
  }
  getFavouriteList(filter: FilterModel){
    return this.apiClient.get(`${ApplicationRoutes.Favorite.FavoritesController}?${this.getQueryString(filter)}`);
  }
}
